import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
export * from "./array"

dayjs.extend(utc)

type LoadTime = {
  delivery_start_time: string
  delivery_end_time: string
  start_time: string
}
export const pageMapper = (item: { results: any[] }) => item.results

export const debounceFunction = (func: Function, wait: number) => {
  let timeout: any

  return function executedFunction(...args: any) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    }

    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

export const filterLoadsWithDateOffset = (offset?: number) => (item: any) => {
  return true
  // if (offset == undefined) return true
  // const date = dayjs().add(offset, 'days').startOf('day')
  // const endDate = dayjs().add(offset, 'days').endOf('day')
  // const startDelDayDiff = dayjs(item.delivery_start_time)
  //   .startOf('day')
  //   .diff(date, 'days')
  // const startDateDiff = dayjs(item.start_time).startOf('day').diff(date, 'days')
  // const endDelDayDiff = dayjs(item.delivery_end_time)
  //   .startOf('day')
  //   .diff(endDate, 'days')
  // return (startDelDayDiff <= 0 && endDelDayDiff >= 0) || startDateDiff === 0
}

export const customerCustomDisplay = (load: any) =>
  (load?.deliveries ?? [])
    ?.reduce(
      (acc: any, crr: any) => {
        return crr.po_number ? [...acc, crr.po_number] : acc
      },
      [load?.smallLoadName]
    )
    .join("\n")

export const filterLoadsWithPhrase = (phrase?: string) => (item: any) => {
  return (
    customerCustomDisplay(item)
      ?.toLowerCase()
      .includes(phrase?.toLowerCase()) ||
    item?.driver?.full_name?.toLowerCase().includes(phrase?.toLowerCase()) ||
    item?.id?.toString()?.includes(phrase?.toLowerCase()) ||
    item?.truck?.serial_number
      ?.toLowerCase()
      ?.includes(phrase?.toLowerCase()) ||
    item?.trailer?.trailer_type
      ?.toLowerCase()
      ?.includes(phrase?.toLowerCase()) ||
    item?.deliveries.some((delivery: any) =>
      delivery?.customer?.company_name
        ?.toLowerCase()
        ?.includes(phrase?.toLowerCase())
    ) ||
    item?.deliveries.some((delivery: any) =>
      delivery?.location?.location_name
        ?.toLowerCase()
        ?.includes(phrase?.toLowerCase())
    ) ||
    item?.pickups
      .flatMap((p: any) => p.bols)
      .some((bol: any) =>
        bol?.name?.toLowerCase()?.includes(phrase?.toLowerCase())
      ) ||
    item?.pickups.some((delivery: any) =>
      delivery?.products?.some((product: any) =>
        product.product.code.toLowerCase().includes(phrase?.toLowerCase())
      )
    ) ||
    item?.pickups.some((delivery: any) =>
      delivery?.products?.some((product: any) =>
        product?.preferences?.some((pref: any) => {
          const prefPhrase =
            [
              pref?.terminal?.name,
              pref?.supplier?.name,
              pref?.loading_number,
              pref?.description,
              pref?.wholesaler,
            ]
              .filter((x) => x)
              .join("-") ?? ""
          return prefPhrase.toLowerCase().includes((phrase ?? "").toLowerCase())
        })
      )
    )
  )
}

export const getDeliveryWindowText = (load: any) => {
  if (load.delivery_start_time === null || load.delivery_end_time === null)
    return "-"
  const isSameDayDelivery = dayjs
    .utc(load.delivery_start_time)
    .isSame(dayjs.utc(load.delivery_end_time), "day")
  const endFormat = isSameDayDelivery ? "ha" : "MMM D, ha"

  const windowText = `${dayjs
    .utc(load.delivery_start_time)
    .local()
    .format("MMM D, ha")} - ${dayjs
    .utc(load.delivery_end_time)
    .local()
    .format(endFormat)}`

  return windowText
}

export const filterLoadsWithOptions =
  (options: { [key: string]: boolean }) => (item: any) => {
    const hasDriver = item?.driver
    const isCommonCarrier = item?.driver?.is_common_carrier
    // if all value are false, consoptions.type, options empty
    if (
      !Object.entries(options).some(
        ([key, item]) => !key.startsWith("lg") && item
      )
    )
      return true
    let totalGallons = 0
    if (options.rtl || options.ltl) {
      totalGallons = item.deliveries
        ?.flatMap((pickup: any) => pickup?.products)
        ?.reduce(
          (acc: number, curr: any) => acc + curr.expected_gross_quantity,
          0
        )
    }
    if (options.rtl && totalGallons > 4500) return true
    if (options.ltl && totalGallons <= 4500) return true
    if (options.inProgress && item.status_code < 7 && item.status_code > 0)
      return true
    // Not sure why this was dependent on start_time before. Have moved it to status_code
    if (options.unscheduled && !item.status_code) return true
    if (options.driver && hasDriver && !isCommonCarrier) return true
    if (options.common_carrier && hasDriver && isCommonCarrier) return true
    if (options.priority && item.priority) return true
    return options[item.status_code]
  }

export const filterLoadsWithLocations = (options: any) => (item: any) => {
  if (!options.length) return true
  return item.deliveries.some((delivery: any) =>
    (delivery?.location?.groups ?? []).some((group: any) =>
      options.includes(group.id)
    )
  )
}

export const filterLoadsWithCustomers = (options: any) => (item: any) => {
  if (!options?.length) return true
  return item?.deliveries?.some((delivery: any) =>
    (options ?? [])?.includes?.(delivery?.customer?.id)
  )
}

export const filterLoadsWithCustomerGroups = (options: any) => (item: any) => {
  if (!options?.length) return true
  return (item?.deliveries ?? []).some((delivery: any) =>
    (delivery?.customer?.groups ?? []).some(({ id }: any) =>
      (options ?? []).includes(id?.toString())
    )
  )
}

export const filterLoadsWithTerminalGroups = (options: any) => (item: any) => {
  if (!options?.length) return true
  return item?.pickups?.some(
    ({ terminal }: any) =>
      terminal &&
      terminal?.groups &&
      terminal?.groups?.some(({ id }: any) => options?.includes(id?.toString()))
  )
}

export function timeout(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export const convertLoad = (load: any) => {
  const deliveries = Object.values(load?.deliveries ?? {}).map(
    (delivery: any) => ({
      ...delivery,
      tickets: delivery.tickets,
      deliveryName: makeLoadName(
        delivery?.customer?.company_name || "-",
        delivery?.location?.location_name || "-"
      ),
      products: Object.values(delivery?.products ?? {}),
    })
  )

  const pickups = Object.values(load?.pickups ?? {}).map((pickup: any) => ({
    ...pickup,
    products: Object.values(pickup?.products),
    bols: Object.values(pickup?.products ?? {}).flatMap(
      (product: any) => product.bols
    ),
  }))
  const isPreLoad = pickups.length && !deliveries.length
  const missingBols = pickups.filter(
    (pickup: any) => pickup.bols.length === 0
  ).length
  const missingTickets = deliveries.filter(
    (delivery: any) => delivery?.tickets?.length === 0
  ).length

  const pumpRequired = deliveries.some(
    (delivery: any) => !!delivery?.location?.pump_required
  )

  const newLoad = {
    ...load,
    isPreLoad,
    deliveries,
    pickups,
    pumpRequired,
    missingBols,
    missingTickets,
  }

  const smallName = getLoadName(newLoad, true)
  const bigName = getLoadName(newLoad)
  const hasMultiple = smallName.name?.toLowerCase()?.includes("multiple")

  return {
    ...newLoad,
    isPreLoad,
    status: isPreLoad ? "Pre-loaded" : load.status,
    driverName: load?.driver?.full_name ?? "",
    delivery_window: getDeliveryWindowText(load),
    smallLoadName: smallName.name,
    fullLoadName: bigName.name,
    hasMultipleDeliveries: hasMultiple,
    hasMultipleLocations: smallName.differentLocations,
  }
}

export const convertCalendarLoad = (load: any) => {
  const deliveries = (load?.deliveries ?? []).map((delivery: any) => ({
    ...delivery,
    tickets: delivery.tickets,
    deliveryName: makeLoadName(
      delivery?.customer?.company_name || "-",
      delivery?.location?.location_name || "-"
    ),
  }))

  const pickups = (load?.pickups ?? []).map((pickup: any) => ({
    ...pickup,
    bols: (pickup?.products ?? []).flatMap((product: any) => product.bols),
  }))
  const isPreLoad = pickups.length && !deliveries.length
  const missingBols = pickups.filter(
    (pickup: any) => pickup.bols.length === 0
  ).length
  const missingTickets = deliveries.filter(
    (delivery: any) => delivery?.tickets?.length === 0
  ).length

  const pumpRequired = deliveries.some(
    (delivery: any) => !!delivery?.location?.pump_required
  )

  const newLoad = {
    ...load,
    isPreLoad,
    deliveries,
    pumpRequired,
    pickups,
    missingBols,
    missingTickets,
  }

  const smallName = getLoadName(newLoad, true)
  const bigName = getLoadName(newLoad)
  const hasMultiple = smallName.name?.toLowerCase()?.includes("multiple")

  return {
    ...newLoad,
    isPreLoad,
    status: isPreLoad ? "Pre-loaded" : load.status,
    driverName: load?.driver?.full_name ?? "",
    delivery_window: getDeliveryWindowText(load),
    smallLoadName: smallName.name,
    fullLoadName: bigName.name,
    hasMultipleDeliveries: hasMultiple,
    hasMultipleLocations: smallName.differentLocations,
  }
}

export const timeSince = (date: Date | null) => {
  if (!date) return ""

  const seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000)
  let interval = Math.floor(seconds / 31536000)
  if (interval < 0) return ""
  if (interval > 1) return interval + "years"

  interval = Math.floor(seconds / 2592000)
  if (interval > 1) return interval + " months"

  interval = Math.floor(seconds / 86400)
  if (interval > 1) return interval + "d"

  interval = Math.floor(seconds / 3600)
  if (interval >= 1) return interval + "h"

  interval = Math.floor(seconds / 60)
  if (interval >= 1) return interval + "m"

  return Math.floor(seconds) + "s"
}

export const makeLoadName = (customer: string, location?: string) => {
  if (location) customer += ` - ${location}`
  return customer
}

const getDeliveryName = (delivery: any) => {
  return [
    delivery?.customer?.company_name,
    delivery?.location?.location_name,
  ].join(" | ")
}

export const getLoadName = (load: any, noLocation?: boolean) => {
  const location = noLocation
    ? ""
    : load?.deliveries?.[0]?.location?.location_name ?? ""
  const customer =
    load?.deliveries?.[0]?.customer?.company_name || `LD-${load.id}`

  const checkName = customer //getDeliveryName(load?.deliveries?.[0])
  const multipleCustomers =
    load?.deliveries?.length > 1 &&
    load?.deliveries?.some(
      (del: any) => del.customer?.company_name !== checkName
    )
  const baseLocation = load?.deliveries?.[0]?.location?.location_name ?? ""
  const differentLocations = load?.deliveries?.some(
    (del: any) => del.location?.location_name !== baseLocation
  )
  const additionToName = load.isPreLoad ? " Pre-load" : ""
  if (
    (multipleCustomers || differentLocations) &&
    load?.deliveries?.length === 2
  ) {
    return {
      name: load?.deliveries
        .map((del: any) => del.location?.location_name)
        .join("/"),
      differentLocations,
    }
  }
  if (!noLocation && (multipleCustomers || differentLocations)) {
    return { name: "Multiple Deliveries", differentLocations }
  }
  if (multipleCustomers)
    return { name: "Multiple Deliveries", differentLocations }

  return {
    name: makeLoadName(customer, location) + additionToName,
    differentLocations,
  }
}

export const getUnassignedProducts = (load: any) => {
  const deliveryProducts = load.deliveries.flatMap((d: any) => d.products)
  const pickupProducts = load.pickups.flatMap((d: any) => d.products)

  return deliveryProducts?.filter((dp: any) =>
    pickupProducts.every((pp: any) => pp.product.id !== dp.product.id)
  )
}

export function componentLoader(lazyComponent: any, attemptsLeft: number) {
  return new Promise((resolve, reject) => {
    lazyComponent()
      .then(resolve)
      .catch((error: any) => {
        // let us retry after 1500 ms
        setTimeout(() => {
          if (attemptsLeft === 1) {
            reject(error)
            return
          }
          componentLoader(lazyComponent, attemptsLeft - 1).then(resolve, reject)
        }, 1500)
      })
  })
}
